/**
 * 날짜 : 2026.09.01
 * 기능 : TUI Grid 셀에 첨부파일 유무를 클립 아이콘 + 개수로 표시하는 렌더러
 *        셀 값(props.value)은 첨부 개수(number)를 받는다. 0이면 아무것도 그리지 않는다
 */

import { createRoot } from 'react-dom/client';
import { t } from 'i18next';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;
  color: var(--text-secondary);

  .material-symbols-rounded {
    font-size: 1.125rem;
    font-variation-settings: 'FILL' 1, 'wght' 400;
  }

  .count {
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1;
  }
`;

class CustomAttachmentRenderer {
  element;

  constructor(props: any) {
    this.element = document.createElement('div');
    const count = Number(props.value) || 0;
    const root = createRoot(this.element);

    // 첨부가 없는 행에 0을 찍으면 목록이 시끄러워지므로 빈 셀로 둔다
    root.render(
      count > 0 ? (
        <Root title={`${t('첨부파일')} ${count}${t('개')}`}>
          <span className='material-symbols-rounded'>attach_file</span>
          <span className='count'>{count}</span>
        </Root>
      ) : null
    );
  }

  getElement() {
    return this.element;
  }
}

export default CustomAttachmentRenderer;
